export const SET_SEND_COST = "send Method: SET";

export function sendCostAction(sendMethod) {
  return {
    type: SET_SEND_COST,
    payload: sendMethod,
  };
}
